'use strict';

export const USERS = {
  // Me
  TOGGLE_WILL_JOIN_PREMIUM: 'Users/TOGGLE_WILL_JOIN_PREMIUM',
  SET_POSSIBLE_PREMIUM_PLAN_TYPE: 'Users/SET_POSSIBLE_PREMIUM_PLAN_TYPE',
  SET_HAS_WAITING_AUTO_RECURRING_PREMIUM: 'Users/SET_HAS_WAITING_AUTO_RECURRING_PREMIUM',
  SET_HAD_REGISTERED_PREMIUM_IN_PAST: 'Users/SET_HAD_REGISTERED_PREMIUM_IN_PAST',
  SET_REVIVABLE_RIGHT: 'Users/SET_REVIVABLE_RIGHT',
  SET_CHANNEL_ID: 'Users/SET_CHANNEL_ID',
  SET_CURRENT_SUBSCRIPTION_ID: 'Users/SET_CURRENT_SUBSCRIPTION_ID',
  SET_CAN_BUY_WITH_ANNUAL_PLAN: 'Users/SET_CAN_BUY_WITH_ANNUAL_PLAN',
  // Users
  ADD: 'Users/ADD'
};

export const FOLLOW = {
  ADD: 'Followers/ADD',
  FOLLOW: 'Followers/FOLLOW',
  UNFOLLOW: 'Followerss/UNFOLLOW'
};

export const PRODUCTS = {
  DATA_RECEIVED: 'Products/DATA_RECEIVED'
};

export const PRODUCT_SKUS = {
  DATA_RECEIVED: 'ProductSkus/DATA_RECEIVED',
  SELECTED: 'ProductSkus/SELECTED',
  WISH_LIST_ITEM_CHANGED: 'ProductSkus/WISH_LIST_ITEM_CHANGED',
  RESTOCK_NOTIFICATION_REGISTERED: 'ProductSkus/RESTOCK_NOTIFICATION_REGISTERED',
  CHANGE_STOCK_COUNT: 'ProductSkus/CHANGE_STOCK_COUNT'
};

export const SEARCH_PRODUCTS = {
  DATA_RECEIVED: 'SearchProducts/DATA_RECEIVED',
  ADDED_TO_WISHLIST: 'SearchProducts/ADDED_TO_WISHLIST',
  CLEAR: 'SearchProducts/CLEAR'
};

export const WISHLIST = {
  DATA_RECEIVED: 'Wishlist/DATA_RECEIVED',
  WISHLIST_STATUS_RECEIVED: 'Wishlist/WISHLIST_STATUS_RECEIVED',
  DATA_CREATED: 'Wishlist/DATA_CREATED',
  DATA_EDITED: 'Wishlist/DATA_EDITED',
  DATA_ADDED: 'Wishlist/DATA_ADDED',
  DATA_REMOVED: 'Wishlist/DATA_REMOVED'
};

export const LABELS = {
  ADD: 'Labels/ADD',
  FOLLOW: 'Labels/FOLLOW',
  UNFOLLOW: 'Labels/UNFOLLOW'
};

export const SHIPPINGS = {
  SERVICE_CHANGE: 'Shippings/SERVICE_CHANGE',
  CLEAR: 'Shippings/CLEAR',
  ADD: 'Shippings/ADD',
  REMOVE: 'Shippings/REMOVE',
  CURRENT_CHANGE: 'Shippings/CURRENT_CHANGE',
  ENABLE: 'Shippings/ENABLE'
};

export const PAYMENTS = {
  SERVICE_CHANGE: 'Payments/SERVICE_CHANGE',
  CLEAR: 'Payments/CLEAR',
  ADD: 'Payments/ADD',
  REMOVE: 'Payments/REMOVE',
  CURRENT_CHANGE: 'Payments/CURRENT_CHANGE',
  UPDATE_BY_ID: 'Payments/UPDATE_BY_ID',
  UPDATE_CARD: 'Payments/UPDATE_CARD'
};

export const ARTICLES = {
  DATA_RECEIVED: 'Articles/DATA_RECEIVED'
};

export const POLLS = {
  DATA_RECEIVED: 'Polls/DATA_RECEIVED'
};

export const POSTS = {
  DATA_RECEIVED: 'Posts/DATA_RECEIVED'
};

export const NOTIFICATIONS = {
  DATA_RECEIVED: 'Notifications/DATA_RECEIVED'
};

export const PREMIUM_SUBSCRIPTION = {
  DATA_RECEIVED: 'PremiumSubscription/DATA_RECEIVED',
  UPDATE_BENEFIT: 'PremiumSubscription/UPDATE_BENEFIT',
  UPDATE_PLAN: 'PremiumSubscription/UPDATE_PLAN',
  UPDATE_PLAN_IMMEDIATELY: 'PremiumSubscription/UPDATE_PLAN_IMMEDIATELY',
  UPDATE_AUTO_RENEWAL: 'PremiumSubscription/UPDATE_AUTO_RENEWAL',
  UPDATE_AUTO_RENEWAL_REMINDER: 'PremiumSubscription/UPDATE_AUTO_RENEWAL_REMINDER'
};

export const PREMIUM_PLAN = {
  UPDATE_PLAN: 'PremiumPlan/UPDATE_PLAN'
};

export const PREMIUM_PLANS = {
  UPSERT: 'PremiumPlans/UPSERT'
};

export const PROJECT_REWARDS = {
  DATA_RECEIVED: 'ProjectRewards/DATA_RECEIVED'
};

export const SHOPPING_CART = {
  DATA_RECEIVED: 'ShoppingCart/DATA_RECEIVED',
  UPDATE_EXPIRATION_SECONDS: 'ShoppingCart/UPDATE_EXPIRATION_SECONDS',
  UPDATE_PRICE: 'ShoppingCart/UPDATE_PRICE',
  UPDATE_SHIPMENTS: 'ShoppingCart/UPDATE_SHIPMENTS',
  UPDATE_PREMIUM: 'ShoppingCart/UPDATE_PREMIUM',
  UPDATE_RECONTRACT_EXTRA_POINT: 'ShoppingCart/UPDATE_RECONTRACT_EXTRA_POINT',
  ENABLE_TO_PURCHASE: 'ShoppingCart/ENABLE_TO_PURCHASE'
};

export const ORDERS = {
  UPSERT: 'Orders/UPSERT',
  UPDATE_LIST: 'Orders/UPDATE_LIST'
};

export const SHIPMENTS = {
  UPSERT: 'Shipments/UPSERT',
  REQUEST_CANCEL: 'Shipments/REQUEST_CANCEL',
  UPDATE_DIGITAL_CONTENT_GIFT_SENT_AT: 'Shipments/UPDATE_DIGITAL_CONTENT_GIFT_SENT_AT',
  CLEAR: 'Shipments/CLEAR',
  CHANGE_QTY: 'Shipments/CHANGE_QTY',
  UPDATE_GIFT_WRAPPING: 'Shipments/UPDATE_GIFT_WRAPPING'
};

export const SHIPMENT_GROUPS = {
  UPSERT: 'ShipmentGroups/UPSERT',
  UPDATE_SHIPPING_ADDRESS: 'ShipmentGroups/UPDATE_SHIPPING_ADDRESS',
  REQUEST_CANCEL: 'ShipmentGroups/REQUEST_CANCEL'
};

export const SHOPPING_DISCOUNTS = {
  DATA_RECEIVED: 'ShoppingDiscounts/DATA_RECEIVED',
  UPSERT: 'ShoppingDiscounts/UPSERT'
};

export const SHOPPING_COUPONS = {
  UPSERT: 'ShoppingCounpons/UPSERT'
};
